import ProductBenefitsSummary from './product-benefits-summary'
import MRTAProductBenefits from './product-benefits-mrta'

const ProductBenefits = ({ displayProduct, sumAssured, basicPremium, coverageTerm, loanTerm }) => {
  return (
    <div id="product-benefits" className="benefit group">
      <ProductBenefitsSummary
        displayProduct={displayProduct}
        sumAssured={sumAssured}
        basicPremium={basicPremium}
        coverageTerm={coverageTerm}
        loanTerm={loanTerm}
      />

      <MRTAProductBenefits displayProduct={displayProduct} sumAssured={sumAssured} />
    </div>
  )
}

export default ProductBenefits
